import { difference, toArray } from 'lodash';
import { SelectionModel } from '@angular/cdk/collections';
import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatChipInput } from '@angular/material/chips';
import { FieldTypeConfig } from '@ngx-formly/core';
import {
  FormlyFieldSelectProps,
  FormlySelectOption,
} from '@ngx-formly/core/select';
import { FieldType } from '@ngx-formly/material/form-field';
import { Subject, takeUntil } from 'rxjs';

interface InputProps extends FormlyFieldSelectProps {
  options: FormlySelectOption[];
  heading: string;
}

@Component({
    selector: 'lockton-apps-chips-autocomplete-type',
    templateUrl: './chips-autocomplete-type.component.html',
    styleUrls: ['./chips-autocomplete-type.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ChipsAutocompleteComponent
  extends FieldType<FieldTypeConfig<InputProps>>
  implements OnInit, OnDestroy
{
  @ViewChild(MatChipInput) input!: MatChipInput;

  control: FormControl = new FormControl<unknown[]>([]);
  selection!: SelectionModel<unknown>;

  destroyed$ = new Subject<void>();

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.selection = new SelectionModel(true, this.field.defaultValue);
    // this.selection.compareWith = (o1, o2) => difference(o1, o2).length === 0;

    this.formControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((value) => {
        const hasDifference =
          difference(value, this.selection.selected).length > 0;
        if (!hasDifference) return;
        this.selection.setSelection(...toArray(value));
      });

    this.selection.changed.pipe(takeUntil(this.destroyed$)).subscribe(() => {
      this.formControl.setValue(this.selection.selected);
    });
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  onOptionSelected(value: unknown): void {
    this.selection.select(value);
    this.control.reset();
    this.input.clear();
  }
}
